<template>
  <div style="font-weight: 400">
    <div class="ccui-top-title">企业信息</div>
    <el-form ref="addform" :model="form" :rules="rules" label-width="160px">
      <el-form-item label="公司名称：" prop="businessName">
        <el-input
          clearable
          v-model.trim="form.businessName"
          class="input-long"
          placeholder="请输入公司名称"
          @blur="getBusinessInfo"
          maxlength="50"
        />
      </el-form-item>
      <el-form-item label="公司简称：" prop="businessShortname">
        <el-input
          clearable
          v-model.trim="form.businessShortname"
          class="input-long"
          placeholder="请输入公司简称"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="unifiedCode">
        <el-input
          clearable
          v-model.trim="form.unifiedCode"
          class="input-long"
          placeholder="请输入统一社会信用代码"
          :disabled="true"
        />
      </el-form-item>
      <div class="ccui-top-title">店铺信息</div>
      <!-- 0-品类经营店 1-产家直营店 2-品牌专卖店 3-综合经营店 4-平台自营店 5-扶贫直销店 6-二级集采店 7-云租店铺 8-物流店铺 -->
      <el-form-item label="店铺类型：" prop="shopType">
        <el-radio-group v-model="form.shopType">
          <el-radio :label="8" v-if="orderPurchaseType == 9">物流专营店</el-radio>
          <el-radio :label="7" v-else-if="orderPurchaseType == 8">租赁专卖店</el-radio>
          <el-radio :label="6" v-else-if="orderPurchaseType == 10">二级集采店</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否内部单位：" prop="isInternalUnit">
        <el-radio-group v-model="form.isInternalUnit">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="店铺名称：" prop="shopName">
        <el-input
          clearable
          v-model.trim="form.shopName"
          class="input-long"
          :placeholder="`单位简称+${getShopName(orderPurchaseType)}`"
          maxlength="50"
        />
        <div class="ccui-tip" style="color: #9b9b9b">
          命名形式：以“单位简称+{{getShopName(orderPurchaseType)}}"命名
          <!-- 以“单位简称+{{getShopName(orderPurchaseType)}}"命名，命名形式:单位简称+专卖店 -->
        </div>
      </el-form-item>
      <el-form-item label="店铺LOGO：" prop="uploadId">
        <fileUpload
          @success="uploadLogo"
          type="LOGO"
          action="/apis/sra/reg/users/signup/uploadFileToOssByShopLoGo"
          :size="[105, 44]"
          :accept="['.png']"
          :fileSize="2"
        >
          <span slot="tip">尺寸：105px*44px，文件格式：png，大小不超过2M</span>
        </fileUpload>
      </el-form-item>

      <el-form-item label="店铺经营地址：" prop="shopAddress">
        <el-input
          clearable
          v-model.trim="form.shopAddress"
          class="input-long"
          placeholder="请输入店铺经营地址"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item label="客服电话：" prop="supportPhone">
        <el-input
          clearable
          v-model.trim="form.supportPhone"
          class="input-long"
          placeholder="请输入客服电话"
          maxlength="30"
        />
      </el-form-item>
      <el-form-item label="店铺简介：" prop="shopBrief">
        <el-input
          maxlength="500"
          clearable
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          class="input-long"
          placeholder="请输入"
          v-model.trim="form.shopBrief"
        />
      </el-form-item>
      <div class="ccui-top-title">注册联系人</div>
      <el-form-item label="姓名：" prop="contactName">
        <el-input
          clearable
          v-model.trim="form.contactName"
          class="input-long"
          placeholder="请输入姓名"
          maxlength="50"
        />
      </el-form-item>
      <el-form-item label="手机号：" prop="phone">
        <div style="display: flex; align-items: center">
          <el-input
            clearable
            v-model.trim="form.phone"
            class="input-long"
            placeholder="请输入手机号"
            maxlength="11"
          />

          <div
            style="font-family: PingFangSC"
            :class="
              isPhoneBtnClick
                ? 'phoneBtn phoneBtn-click'
                : 'phoneBtn phoneBtn-default'
            "
            @click="getTestCode"
          >
            {{ isPhoneBtnClick ? phoneBtnTxt + "秒" : phoneBtnTxt }}

            <div class="islider" v-if="isCode">
              <Slider
                @close="isCode = false"
                :log="true"
                @getImg="getImg"
                @validImg="validImg"
              ></Slider>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="验证码：" prop="authCode">
        <el-input
          clearable
          v-model.trim="form.authCode"
          class="input-long"
          placeholder="请输入验证码"
          maxlength="8"
        />
      </el-form-item>
      <div class="ccui-top-title">上传材料</div>
      <el-form-item label="授权委托书：" prop="isfileBos">
        <el-input v-model="form.isfileBos" v-show="false"></el-input>
        <fileUpload @success="uploadSuccess" :limit="1"></fileUpload>
      </el-form-item>
    </el-form>
  </div>
</template>
  
  <script>
import fileUpload from "./fileUpload.vue";
import validators from "@/utils/validators";
import { getSendMsg, getImageVerifyCode } from "@/api/register-shop";

import { qrySupInfoListItem } from "@/api/lessor-open-shop.js";
import Slider from "@/views/common/slider.vue";
export default {
  components: {
    fileUpload,
    Slider,
  },
  data() {
    return {
      phoneBtnTxt: "发送验证码",
      isPhoneBtnClick: false,
      isCode: false,
      form: {
        businessName: "", //公司名称
        businessShortname: "", //公司简称
        unifiedCode: "", //统一社会信用代码
        shopType: '', //店铺类型
        shopName: "", //店铺名称
        shopLogoUrl: "", //店铺LOGO
        shopAddress: "", //店铺经营地址
        supportPhone: "", //客服电话
        shopBrief: "", //店铺简介
        contactName: "", //注册联系人姓名
        phone: "", //注册联系人手机号
        authCode: "", //验证码
        fileBos: [], //授权委托书
        isInternalUnit: 0, //是否内部单位  0-否 1-是
        isDomesticTrade: null, //是否内贸单位  0-否 1-是
        isfileBos: "", //授权委托书
      },
      canEdit: true,
      rules: {
        businessName: [
          { required: true, message: "请输入公司名称", trigger: "change" },
        ],
        businessShortname: [
          { required: true, message: "请输入公司简称", trigger: "change" },
        ],
        shopBrief: [
          { required: false, message: "请输入店铺简介", trigger: "change" },
        ],
        isfileBos: [
          { required: true, message: "请上传授权委托书", trigger: "change" },
        ],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
          //   {
          //     pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
          //     message: "请输入正确的统一社会信用代码",
          //     trigger: "change",
          //   },
          //   {
          //     max: 18,
          //     min: 18,
          //     message: "请输入正确的统一社会信用代码",
          //     trigger: "change",
          //   },
        ],
        shopType: [
          { required: true, message: "请选择店铺类型", trigger: "change" },
        ],
        shopName: [
          { required: true, message: "请输入店铺名称", trigger: "change" },
        ],

        contactName: [
          { required: true, message: "请输入真实姓名", trigger: "change" },
          {
            // pattern: /^[\u4e00-\u9fa5A-Za-z\s\·\(\)\（\）]+$/,
            // message: '请正确填写姓名',
            pattern: /^((?!.*(&)).)*$/,
            message: "不可输入&",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
        ],
        authCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
      olist:[
        {
          orderPurchaseType: 8,
          name: "租赁专卖店",
          sname:'租赁专卖店',
          shopType: 7,
        },
        {
          orderPurchaseType: 9,
          name: "物流专营店",
          sname:'物流专营店',
          shopType: 8,
        },
        {
          orderPurchaseType: 10,
          name: "二级集采店",
          sname:'集采店',
          shopType: 6,
        }
      ]
    };
  },
  computed: {
    orderPurchaseType() {
      const aa = this.$route.query.orderPurchaseType || 8;
      const bb = this.olist.find((item) => item.orderPurchaseType == aa);
      this.form.shopType = bb.shopType
      return aa;
    },
  },
  methods: {
    getShopName(orderPurchaseType){
      const cc = this.olist.find((item) => item.orderPurchaseType == orderPurchaseType);
      return cc.sname
    },
    getMoRenBusinessName(){
      const mName = this.$route.query.supName || '';
      this.form.businessName = mName;
      setTimeout(() => {
        this.getBusinessInfo();
      }, 1000);
    },
    getBusinessInfo() {
      if (!this.form.businessName) return;

      qrySupInfoListItem({
        supName: this.form.businessName,
        isShowLoading: true,
      }).then((res) => {
        console.log(res, "获取商家信息");

        if (res.data.code == 0) {
          const info = res.data.data.emVendorInfoBO;
          if (info) {
            this.form.businessName = info.vendorNameCn;
            this.form.businessShortname = info.vendorSortName;
            this.form.unifiedCode = info.unifySocialCreditCodes;
          } else {
            this.form.businessShortname = "";
            this.form.unifiedCode = "";
            this.$message({
              showClose: true,
              type: "error",
              message: "请确认公司名称是否正确，是否已完成统一入网认证",
              ccuiCustom: true,
            });
          }
        }
      });
    },

    uploadLogo(fileList) {
      if (fileList.length > 0) {
        this.form.shopLogoUrl = fileList[0].downloadUrl;
        this.form.uploadId = fileList[0].uploadId;
      } else {
        this.form.shopLogoUrl = "";
        this.form.uploadId = "";
      }
    },
    uploadSuccess(fileList) {
      this.form.fileBos = fileList.map((el) => {
        return {
          fileName: el.fileName, //资质名称
          uploadId: el.uploadId, //上传文件id
          uploadTime: el.uploadTime, //上传时间
          isLongValidity: 1, //是否长期有效: 0-否 1-是
          isDefault: 1, //是否默认: 0-否 1-是
        };
      });
      this.form.isfileBos = this.form.fileBos.length ? 1 : "";
    },
    phoneBtnClick(blcokLeft, id, callback) {
      this.getCode(blcokLeft, id, callback);
    },
    getCode(blcokLeft, id, callback) {
      getSendMsg({
        phone: this.form.phone,
        captchaVail: { x: blcokLeft, catuid: id },
      }).then((res) => {
        console.log(res, "发送短信验证码接口");
        if (res.data.code == "0") {
          callback({ data: true });
          this.isCode = false;
          this.show = false;
          let timer;
          this.isPhoneBtnClick = true;
          this.phoneBtnTxt = 60;
          timer = setInterval(() => {
            this.phoneBtnTxt = --this.phoneBtnTxt;
            if (!this.phoneBtnTxt) {
              this.isPhoneBtnClick = false;
              this.phoneBtnTxt = "发送验证码";
              clearInterval(timer);
            }
          }, 1000);
        } else {
          callback({ data: false, message: res.data.message });
          this.isCode = true;
          this.show = true;
        }
      });
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then(
        (res) => {
          callback(res.data);
        },
        (error) => {
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.phoneBtnClick(blcokLeft, id, callback); // 登陆请求方法
    },
    getTestCode() {
      this.$refs["addform"].validateField("phone", (valid) => {
        if (!valid) {
          if (!this.isPhoneBtnClick) {
            this.isCode = true;
          }
        }
      });
    },
    handleSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["addform"].validate((valid) => {
          if (!valid) return reject("表单校验失败");
          const da = {
            ...this.form,
            shopManagerPhone: this.form.phone,
            shopManager: this.form.contactName,
          };
          resolve(da);
        });
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.ccui-top-title{
  margin-bottom: 20px;
}
.phoneBtn {
  border-radius: 4px;
  font-size: 13px;
  width: 85px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.phoneBtn-default {
  background-color: rgba(255, 20, 47, 1);
  &:hover {
    background: #f50b25;
  }
}
.phoneBtn-click {
  background: #cccccc;
  border: 1px solid rgba(204, 204, 204, 1);
  color: #999999;
}
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  left: 252px;
  top: -280px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
</style>